<script setup lang="ts"></script>

<template>
  <FooterContentContainer>
    <div class="gap-r6 flex flex-col justify-between xl:flex-row">
      <FooterContentLogo />
      <FooterContentLinks />
      <FooterContentSocials />
      <FooterContentContact />
    </div>
  </FooterContentContainer>
</template>
